import { facadeApi } from 'api'
import { RolePermissions } from 'types/roles/roles'

export interface Params {
  roleUid: string
}

export const fetchRolePermissionsApi = ({ roleUid }: Params) =>
  facadeApi.get<RolePermissions[]>(`/az/v2/roles/${roleUid}/permissions`)
